exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tw-color-readout_readout_3RxI3 {\n  width: 28px;\n  height: 16px;\n  text-align: center;\n  -moz-appearance: textfield;\n  font: inherit;\n  font-weight: bold;\n}\n[dir=\"ltr\"] .tw-color-readout_readout_3RxI3 {\n  margin-left: 10px;\n}\n[dir=\"rtl\"] .tw-color-readout_readout_3RxI3 {\n  margin-right: 10px;\n}\n.tw-color-readout_readout_3RxI3::-webkit-outer-spin-button,\n.tw-color-readout_readout_3RxI3::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"readout": "tw-color-readout_readout_3RxI3"
};